// src/pages/admin/Users.jsx
import { useState } from 'react'
import { functions } from '../../firebase'
import { httpsCallable } from 'firebase/functions'

export default function AdminUsers(){
  const [email, setEmail] = useState('')
  const [vendorId, setVendorId] = useState('')
  const [role, setRole] = useState('vendor')
  const [result, setResult] = useState(null)

  async function setRoleFn(e){
    e.preventDefault()
    const call = httpsCallable(functions, 'setUserRole')
    const { data } = await call({ email, role, vendorId })
    setResult(data)
  }

  return (
    <div className="card-modern p-4">
      <h3>Rôles & Accès</h3>
      <form className="row g-3" onSubmit={setRoleFn}>
        <div className="col-md-4">
          <label className="form-label">Email utilisateur</label>
          <input className="form-control" value={email} onChange={e=>setEmail(e.target.value)} required />
        </div>
        <div className="col-md-3">
          <label className="form-label">Rôle</label>
          <select className="form-select" value={role} onChange={e=>setRole(e.target.value)}>
            <option value="vendor">Vendor</option>
            <option value="admin">Admin</option>
          </select>
        </div>
        <div className="col-md-3">
          <label className="form-label">Vendor ID</label>
          <input className="form-control" value={vendorId} onChange={e=>setVendorId(e.target.value)} placeholder="ex: v1" />
        </div>
        <div className="col-md-2 d-flex align-items-end">
          <button className="btn btn-primary w-100">Assigner</button>
        </div>
      </form>
      {result && <div className="alert alert-success mt-3">OK: {JSON.stringify(result)}</div>}
      <div className="small text-muted mt-2">Seuls les admins peuvent utiliser cette page.</div>
    </div>
  )
}
